import global from "../../config/global";
import storeActions from '../../store/actions';

import common from ".";

import commonSocketSh from "../../web-sh/src/utils/common/socket";

const syncDataByWs = async (message) => {
  const eventType = message.type;
  global.store.dispatch(storeActions.updateSyncing(true))
  if (eventType === 'user_update_plan') {
    common.getPaymentPlan();
    common.getPlanLimit();
  } else if (['cipher_share', 'collection_update', 'cipher_invitation'].includes(eventType)) {
    common.getPlanLimit();
  }
  await commonSocketSh.syncDataByWs(message);
  global.store.dispatch(storeActions.updateSyncing(false))
}

export default {
  syncDataByWs
}